import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { fetchCaseNotes, updateCaseNotes } from "js/Api/index";
import EditIcon from "@mui/icons-material/EditRounded";

function CaseNotesTab({ user }) {
  const [caseNotes, setCaseNotes] = useState("");
  const [originalNotes, setOriginalNotes] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchNotes();
  }, [user.id]);

  const fetchNotes = async () => {
    setIsLoading(true);
    const result = await fetchCaseNotes(user.id);
    
    if (result.success) {
      // Log the response to debug

      
      // Properly extract case notes from response based on the backend format
      let notes = "";
      if (result.data) {
        if (result.data.CaseNotes !== undefined) {
          notes = result.data.CaseNotes;
        } else if (result.data.caseNotes !== undefined) {
          notes = result.data.caseNotes;
        } else if (result.data.case_notes !== undefined) {
          notes = result.data.case_notes;
        }
      }
      
      setCaseNotes(notes);
      setOriginalNotes(notes);
    } else {
      toast.error(result.error || "Failed to fetch case notes");
    }
    setIsLoading(false);
  };

  const handleSave = () => {
    // Only show modal if there are actual changes
    if (caseNotes !== originalNotes) {
      setShowUpdateModal(true);
    } else {
      toast("No changes to save", {
        icon: "ℹ️",
        style: {
          background: "#e3f2fd",
          color: "#1976d2",
        },
      });
      setIsEditMode(false);
    }
  };

  const handleCancel = () => {
    setCaseNotes(originalNotes);
    setIsEditMode(false);
    toast("Changes discarded", {
      icon: "ℹ️",
      style: {
        background: "#e3f2fd",
        color: "#1976d2",
      },
    });
  };

  const handleConfirmUpdate = async () => {
    const result = await updateCaseNotes(user.id, caseNotes);
    
    if (result.success) {
      toast.success("Case notes updated successfully");
      setOriginalNotes(caseNotes);
      setIsEditMode(false);
    } else {
      toast.error(result.error || "Failed to update case notes");
    }
    
    setShowUpdateModal(false);
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  return (
    <div style={{ marginLeft: "40px", marginBottom: "30px" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <h4 style={{ marginRight: "10px", marginBottom: "0" }}>Case Notes</h4>
        {!isEditMode && !isLoading && (
          <div
            onClick={handleEdit}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              color: "#000",
            }}
            title="Edit case notes"
          >
            <EditIcon sx={{ fontSize: "1.2rem" }} />
          </div>
        )}
      </div>
      <p>Important information about this device and its user.</p>
      
      <div style={{ marginTop: "20px", marginBottom: "30px" }}>
        {isLoading ? (
          <div>Loading case notes...</div>
        ) : isEditMode ? (
          <textarea
            value={caseNotes}
            onChange={(e) => setCaseNotes(e.target.value)}
            style={{
              width: "100%",
              minHeight: "200px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontFamily: "inherit",
              resize: "vertical"
            }}
            placeholder="Enter case notes here..."
          />
        ) : (
          <div 
            style={{
              width: "100%",
              minHeight: "200px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f9f9f9",
              whiteSpace: "pre-wrap"
            }}
          >
            {caseNotes || "No case notes available."}
          </div>
        )}
      </div>
      
      {isEditMode && (
        <div style={{ display: "flex", gap: "10px" }}>
          <button 
            onClick={handleSave} 
            className="btn cur-p btn-primary"
            disabled={isLoading}
          >
            Save
          </button>
          <button 
            onClick={handleCancel} 
            className="btn cur-p btn-secondary"
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )}

      {/* Confirmation Modal */}
      {showUpdateModal && (
        <div className="modal" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{ width: "400px" }}>
              <div className="modal-header">
                <h1 className="modal-title">Update Case Notes</h1>
                <button 
                  className="close-button" 
                  onClick={() => setShowUpdateModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to update the case notes for {user.name}?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn cur-p btn-secondary"
                  onClick={() => setShowUpdateModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn cur-p btn-primary"
                  onClick={handleConfirmUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CaseNotesTab;